import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestType, DigitalLeadBg, PaperLeadBg } from 'Pages/ibro'
import { Callback } from 'Types/utilTypes'

export namespace BgLeadNs {
	export type LeadComplete = PayloadAction<{
		id: number
		status: boolean
		info: { shortname: string; purchasecode: string; inn: string }
		requestType?: RequestType
	}>
	export type ChangeLead = PayloadAction<{
		requestType?: RequestType
		id: number
		lead_id: number
		changeOptions?: { is_director: boolean }
	}>
	export type SendPaperLead = PayloadAction<{
		requestType?: RequestType
		id: number
		data: PaperLeadBg
	}>
	export type SendDigitalLead = PayloadAction<{
		requestType?: RequestType
		id: number
		data: DigitalLeadBg
	}>
	export type SendConfirmation = PayloadAction<{
		requestType?: RequestType
		id: number
		phone: string
		attorney?: boolean
		is_director?: boolean
	}>
	export type CheckPersonalDataAgreement = PayloadAction<string>
	export type RequestNewLead = PayloadAction<{ callback?: Callback }>
}

export const bgLeadSlice = createSlice({
	name: 'bgLead',
	initialState: {},
	reducers: {
		leadCompleteBg: (state, action: BgLeadNs.LeadComplete) => {},
		changeLeadBg: (state, action: BgLeadNs.ChangeLead) => {},
		sendConfirmation: (state, action: BgLeadNs.SendConfirmation) => {},
		sendPaperLead: (state, action: BgLeadNs.SendPaperLead) => {},
		sendDigitalLead: (state, action: BgLeadNs.SendDigitalLead) => {},
		checkPersonalDataAgreement: (state, action: BgLeadNs.CheckPersonalDataAgreement) => {},
		cancelCheckPersonalDataAgreement: () => {},
		requestNewLead: (state, action: BgLeadNs.RequestNewLead) => {},
	},
})
